module.exports = __webpack_public_path__ + "img/icon_up.addd5806.png";